import CookieButton from './cookie-button';

export default class CookieInfo extends CookieButton {
    setContainerDisplay() {
        if (super.cookieWasAccepted()) document.querySelector('.cookie-info').classList.add('is-hidden');
    }

    constructor(buttonQuerySelector) {
        super(buttonQuerySelector);
        this.setContainerDisplay();
    }
}
